import React, { useState, useEffect } from "react";

const AuthContext = React.createContext([{}, () => {}]);

// Load initial state from localStorage
let initialState = JSON.parse(localStorage.getItem("managerAuthState")) || {};

const AuthProvider = (props) => {
  const [state, setState] = useState(initialState);

  // Update localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem("managerAuthState", JSON.stringify(state));
  }, [state]);

  return (
    <AuthContext.Provider value={[state, setState]}>
      {props.children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
